// Auth0 error codes that all mean "this session is no longer valid — force re-login"
const STALE_SESSION_CODES = new Set([
  "login_required",       // Auth0 server-side session gone (expired, cleared, or never existed)
  "missing_refresh_token",// No refresh token found in the SDK cache
  "invalid_grant",        // Token revoked, absolute expiry hit, session cleared, already consumed by another tab
  "access_denied",        // User blocked or deleted in Auth0 dashboard, or consent revoked
  "interaction_required", // Auth0 requires user interaction to continue (similar to login_required)
  "consent_required",     // User must re-grant consent (e.g. scope changed)
]);

export const isStaleSessionError = (error) => {
  if (!error) return false;
  const code = error?.error ?? error?.code;
  return STALE_SESSION_CODES.has(code);
};

// localStorage key used to broadcast logout intent to all other open tabs
export const CROSS_TAB_LOGOUT_KEY = "cxf_force_logout";
